
































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import Holidays from 'date-holidays';
import {AMETRAS_HOLIDAY_UTILS_INST, ExtendedHolidays} from '@/services/holiday.service';
import {FieldStyleContext} from '@/fields/field-style-context';

/**
 * General Component for Fields of type HOLIDAY
 */
@Component({
  mixins: [BindAttrs]
})
export default class AmetrasHolidayFieldTemplate extends Vue {

  @Prop() textAlign!: 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';
  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() value!: DisguiseDto.HolidayDto;
  @Prop() label!: string;
  @Prop() readonly!: boolean;
  @Prop() styleContext!: FieldStyleContext;

  holidays = new Holidays();
  innerValue: ExtendedHolidays | null = null;
  holidayCountriesAndStates = AMETRAS_HOLIDAY_UTILS_INST.getAllPossibleValues();

  @Watch('value') valueChanged(newValue: DisguiseDto.HolidayDto, oldValue: DisguiseDto.HolidayDto) {
    if (newValue !== oldValue) {
      this.setInnerValue(newValue);
    }
  }

  created() {
    this.setInnerValue(this.value);
  }

  countryChanged(args: ExtendedHolidays) {
    const changes: DisguiseDto.HolidayDto = {};
    if (args !== null) {
      this.innerValue = args;
      changes.country = args.holidayCountry.country;
      changes.state = args.holidayCountry.state;
    }
    this.$emit('input', changes);
    this.$emit('change', changes);
  }

  captureEnterKey(event: Event) {
    const isAnySelectBoxOpened = document.querySelectorAll('.v-select--is-menu-active').length !== 0;
    if (isAnySelectBoxOpened) {
      event.stopPropagation();
    } else {
      event.stopImmediatePropagation();
    }
  }

  private setInnerValue(newValue: DisguiseDto.HolidayDto) {
    this.innerValue = AMETRAS_HOLIDAY_UTILS_INST.getFromHolidayDto(newValue);
  }
}

